(function (global) {
  'use strict';

  function isWorkingDay(date, workingSet) {
    return workingSet.has(date.getDay());
  }

  function nextWorkingDay(date, workingSet) {
    var d = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
    while (!workingSet.has(d.getDay())) {
      d.setDate(d.getDate() + 1);
    }
    return d;
  }

  // n == 0 ritorna la stessa data normalizzata a mezzanotte (non forza un giorno lavorativo:
  // i chiamanti passano sempre una base gia' lavorativa).
  function advanceWorkingDays(date, n, workingSet) {
    var d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    for (var i = 0; i < n; i++) {
      d = nextWorkingDay(d, workingSet);
    }
    return d;
  }

  function isSameDate(a, b) {
    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
  }

  function computeDispatch(now, cutoffMinutes, workingSet) {
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var nowMinutes = now.getHours() * 60 + now.getMinutes();
    if (isWorkingDay(today, workingSet) && nowMinutes < cutoffMinutes) {
      return { date: today, shipsToday: true };
    }
    return { date: nextWorkingDay(today, workingSet), shipsToday: false };
  }

  function computeWindow(dispatch, minDays, maxDays, workingSet) {
    var lo = Math.min(minDays, maxDays);
    var hi = Math.max(minDays, maxDays);
    return {
      from: advanceWorkingDays(dispatch, lo, workingSet),
      to: advanceWorkingDays(dispatch, hi, workingSet)
    };
  }

  function formatDate(date, locale) {
    var wd = new Intl.DateTimeFormat(locale, { weekday: 'short' });
    var dayNum = new Intl.DateTimeFormat(locale, { day: 'numeric' });
    var month = new Intl.DateTimeFormat(locale, { month: 'short' });
    return wd.format(date) + ' ' + dayNum.format(date) + ' ' + month.format(date);
  }

  function parseTemplate(template, values) {
    var segments = [];
    var re = /%(\w+)%/g;
    var last = 0;
    var m;
    while ((m = re.exec(template)) !== null) {
      if (m.index > last) segments.push({ text: template.slice(last, m.index), strong: false });
      var key = m[1];
      var has = Object.prototype.hasOwnProperty.call(values, key);
      segments.push({ text: has ? String(values[key]) : m[0], strong: has });
      last = m.index + m[0].length;
    }
    if (last < template.length) segments.push({ text: template.slice(last), strong: false });
    if (segments.length === 0) segments.push({ text: template, strong: false });
    return segments;
  }

  function computeLines(dispatchDate, transitMin, transitMax, transitPremium, workingSet) {
    var win = computeWindow(dispatchDate, transitMin, transitMax, workingSet);
    return {
      single: isSameDate(win.from, win.to),
      from: win.from,
      to: win.to,
      premium: advanceWorkingDays(dispatchDate, transitPremium, workingSet)
    };
  }

  function nowInZone(timeZone, baseDate) {
    var src = baseDate || new Date();
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone,
      year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false
    }).formatToParts(src);
    function get(type) { return Number(parts.find(function (p) { return p.type === type; }).value); }
    var hour = get('hour'); if (hour === 24) hour = 0;
    return new Date(get('year'), get('month') - 1, get('day'), hour, get('minute'), get('second'));
  }

  var api = {
    isWorkingDay: isWorkingDay,
    nextWorkingDay: nextWorkingDay,
    advanceWorkingDays: advanceWorkingDays,
    isSameDate: isSameDate,
    computeDispatch: computeDispatch,
    computeWindow: computeWindow,
    computeLines: computeLines,
    formatDate: formatDate,
    parseTemplate: parseTemplate,
    nowInZone: nowInZone
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }

  if (typeof HTMLElement !== 'undefined' && typeof customElements !== 'undefined' && !customElements.get('tk-delivery-estimate')) {
    var TIMEZONE = 'Europe/Rome';

    function buildWorkingSet(el) {
      var set = new Set([1, 2, 3, 4, 5]);
      if (el.dataset.saturday === 'true') set.add(6);
      if (el.dataset.sunday === 'true') set.add(0);
      return set;
    }

    class TkDeliveryEstimate extends HTMLElement {
      connectedCallback() {
        this.primary = this.querySelector('[data-role="primary"]');
        if (!this.primary) return;
        this.secondary = this.querySelector('[data-role="secondary"]');
        this.locale = this.dataset.locale || 'it';
        this.cutoffMinutes = Number(this.dataset.cutoffHour) * 60 + Number(this.dataset.cutoffMinute);
        this.transitMin = Number(this.dataset.transitMinDays);
        this.transitMax = Number(this.dataset.transitMaxDays);
        this.transitPremium = Number(this.dataset.transitPremiumDays);
        this.workingSet = buildWorkingSet(this);
        this.render();
        this.timer = setInterval(this.render.bind(this), 60000);
      }

      disconnectedCallback() {
        if (this.timer) clearInterval(this.timer);
      }

      renderLine(el, template, values) {
        var segments = parseTemplate(template, values);
        el.textContent = '';
        segments.forEach(function (seg) {
          if (seg.strong) {
            var strong = document.createElement('strong');
            strong.textContent = seg.text;
            el.appendChild(strong);
          } else {
            el.appendChild(document.createTextNode(seg.text));
          }
        });
      }

      render() {
        var now = nowInZone(TIMEZONE);
        var dispatch = computeDispatch(now, this.cutoffMinutes, this.workingSet);
        var lines = computeLines(dispatch.date, this.transitMin, this.transitMax, this.transitPremium, this.workingSet);

        if (lines.single) {
          this.renderLine(this.primary, this.dataset.tplStandardSingle || '', {
            date: formatDate(lines.from, this.locale)
          });
        } else {
          this.renderLine(this.primary, this.dataset.tplStandardRange || '', {
            from: formatDate(lines.from, this.locale),
            to: formatDate(lines.to, this.locale)
          });
        }

        if (this.secondary) {
          this.renderLine(this.secondary, this.dataset.tplPremium || '', {
            date: formatDate(lines.premium, this.locale)
          });
        }
      }
    }

    customElements.define('tk-delivery-estimate', TkDeliveryEstimate);
  }
})(typeof window !== 'undefined' ? window : this);
